<template>
  <ModalPopup :is-visible="isVisible" title="개인정보처리방침" size="lg" class="modal-policy" @close="handleClose">
    <div class="policy-content">
      <h1>개인정보처리방침</h1>
      <p>주식회사 오션블루(이하 '회사'라 합니다.)는 고객의 개인정보보호를 소중하게 생각하고, 고객의 개인정보를 보호하기 위하여 항상 최선을 다하고 있습니다.</p>
      <p>회사는 「개인정보 보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「위치정보의 보호 및 이용 등에 관한 법률」 등 관련 법령을 준수하며, 이를 회사가 운영하는 서비스(웹 및 모바일 사이트, 스마트폰 앱을 포함합니다.)에 공개하여 고객이 언제나 용이하게 열람할 수 있도록 하고 있습니다.</p>
      <p>회사는 정부의 법률 및 지침 변경 등에 따라 수시로 개인정보 처리방침을 바꿀 수 있고, 이에 따른 개인정보 처리방침의 지속적인 개선을 위하여 필요한 절차를 정하고 있습니다. 그리고 개인정보 처리방침을 개정하거나 변경할 때에는 아래 부칙에서 정한 절차에 따라 "서비스" 내 공지사항 등을 통해 고지하고 있습니다.</p>
      <p>본 개인정보 처리방침은 '휴대폰 분실 피해 방지(폰지킴)'(이하 "서비스"라 합니다.)를 이용하는 고객에 대하여 적용되며, 고객이 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보 보호를 위하여 어떠한 조치를 취하고 있는지 아래와 같은 내용을 담고 있습니다.</p>
      <h2>제1조(개인정보의 처리 목적, 수집 항목, 보유 및 이용 기간)</h2>
      <p>① 본 "서비스"는 이동통신사(LG U+, SKT)의 월정액 유료부가서비스로, "회사"는 다음과 같이 개인정보를 수집·이용합니다.</p>
      <div class="table-wrap"><table>
      <thead>
      <tr>
      <th><strong>처리 업무</strong></th>
      <th><strong>수집·이용 목적</strong></th>
      <th><strong>수집·이용 항목</strong></th>
      <th><strong>보유 및 이용 기간</strong></th>
      </tr>
      </thead>
      <tbody>
      <tr>
      <td>회원가입·로그인</td>
      <td>본인인증, 회원 식별, 로그인</td>
      <td>휴대폰 번호, 이동통신사, 성명, 생년월일, 성별</td>
      <td>해지(탈퇴) 시 즉시 삭제<br>단, 다른 법령에 특별한 규정이 있을 경우 관련 법령에 따라 보관</td>
      </tr>
      <tr>
      <td>유료 가입·정산</td>
      <td>서비스 가입/해지, 월정액 정산, 만 19세 이상 여부 확인</td>
      <td>휴대폰 번호, 성명, 생년월일, 부가서비스 가입/해지 일자, 부가서비스 가입 여부, 번호이동 여부</td>
      <td>서비스 해지 시 즉시 삭제<br>단, 다른 법령에 특별한 규정이 있을 경우 관련 법령에 따라 보관</td>
      </tr>
      <tr>
      <td>계정 관리</td>
      <td>본인 확인, 비밀번호 재설정, 계정 안내</td>
      <td>이메일</td>
      <td>해지 시 즉시 삭제</td>
      </tr>
      <tr>
      <td>단말 보호</td>
      <td>분실 모드 실행, 앱 차단, 잠금화면 메시지 표시, 원격 사이렌, 보호 상태 표시</td>
      <td>단말 정보(모델명, OS 종류·버전, 단말 식별값), 연락받을 번호</td>
      <td>해지 시 즉시 삭제<br>단, 다른 법령에 특별한 규정이 있을 경우 관련 법령에 따라 보관</td>
      </tr>
      <tr>
      <td>비상 연락처</td>
      <td>분실 모드 시 비상 연락처에 문자 자동 발송, 발송 내역 제공</td>
      <td>비상 연락처의 이름, 관계, 휴대폰 번호</td>
      <td>해지 또는 삭제 요청 시 즉시 삭제<br>단, 다른 법령에 특별한 규정이 있을 경우 관련 법령에 따라 보관</td>
      </tr>
      <tr>
      <td>위치 추적</td>
      <td>“홈페이지”에서 분실 단말 위치 확인</td>
      <td>단말 위치정보(GPS, 기지국, Wi-Fi 기반), 위치 확인 시각, 변환된 주소</td>
      <td>해지 또는 삭제 요청 시 즉시 삭제<br>단, 다른 법령에 특별한 규정이 있을 경우 관련 법령에 따라 보관</td>
      </tr>
      <tr>
      <td>분실 신고·유심</td>
      <td>통신사 분실 신고 감지, 유심 교체 이력 표시 및 알림</td>
      <td>휴대폰 분실 신고 상태 정보, 유심 분리·장착 이력 및 일시, 알림을 받을 번호</td>
      <td>해지 시 즉시 삭제<br>단, 다른 법령에 특별한 규정이 있을 경우 관련 법령에 따라 보관</td>
      </tr>
      <tr>
      <td>가족 보호</td>
      <td>가족 초대, 가족 단말 보호 및 상태 확인</td>
      <td>가족의 이름, 휴대폰 번호, 관계, 단말 OS, 가족 단말의 위치정보, 유심 변경 이력</td>
      <td>가족 삭제 또는 해지 시 즉시 삭제<br>단, 다른 법령에 특별한 규정이 있을 경우 관련 법령에 따라 보관</td>
      </tr>
      <tr>
      <td>쿠폰</td>
      <td>쿠폰 포인트 지급, 쿠폰 발급 및 사용 내역 제공</td>
      <td>휴대폰 번호, 쿠폰 포인트·신청·사용 내역, 쿠폰 번호, 이름</td>
      <td>해지 시 즉시 삭제. 단, 거래 기록은 법령에 따라 보관</td>
      </tr>
      <tr>
      <td>이벤트</td>
      <td>경품 배송</td>
      <td>이름, 휴대폰 번호, 주소, 신분증 사본(제세공과금 대상일 때)</td>
      <td>해지 시 즉시 삭제</td>
      </tr>
      <tr>
      <td>해지</td>
      <td>해지 처리 및 서비스 개선</td>
      <td>해지 일시</td>
      <td>해지 후 6개월 보관 후 파기</td>
      </tr>
      <tr>
      <td>고객센터</td>
      <td>문의 대응</td>
      <td>이름, 휴대폰 번호, 문의 내용, 답변 내용, 녹취 데이터, 계좌번호(환불 요청 시)</td>
      <td>상담 이력 3년, 녹취 데이터 5년 보관 후 파기</td>
      </tr>
      </tbody>
      </table></div>
      <p>② "서비스" 이용 과정에서 다음 정보가 자동으로 생성되어 수집될 수 있습니다.</p>
      <p>- IP Address, 쿠키, 서비스 방문 경로/일시, 가입 경로/일시, 서비스 신청/이용/해지/실행 기록, 알림 설정 및 수신 기록, 불량 이용 기록</p>
      <p>③ "가족"(게스트)의 개인정보와 위치정보는 해당 "가족"이 초대를 수락하고 "가족"(게스트)앱에서 별도로 동의한 경우에만 보호자에게 제공합니다.</p>
      <p>④ "회사"는 사상·신념, 건강 등 민감정보를 수집하지 않습니다. 다만, 이벤트 경품이 제세공과금 대상인 경우에 한하여 「소득세법」 등 관계 법령에 근거하여 신분증 사본(주민등록번호 등 고유식별정보 포함)을 수집·이용하며, 제세공과금 처리 외의 목적으로는 이용하지 않습니다.</p>
      <p>⑤ "가입자"는 개인정보 수집·이용에 동의하지 않을 권리가 있습니다. 다만, 제1조의 개인정보는 "서비스" 제공에 필요한 필수 항목으로, 동의하지 않으면 "서비스" 가입 및 이용이 불가능합니다. 단말 권한은 거부할 수 있으나, 거부 시 해당 기능(위치 추적, 앱 차단 등)을 이용할 수 없습니다.</p>
      <h2>제2조(관계 법령에 따른 보존)</h2>
      <p>"가입자"의 개인정보는 해지 시 파기하는 것을 원칙으로 하나, 관계 법령에 따라 다음 기간 동안 보존합니다.</p>
      <p>1. 서비스 이용 관련 기록: 3개월(「통신비밀보호법」)</p>
      <p>2. 계약 또는 청약철회 등에 관한 기록: 5년(「전자상거래 등에서의 소비자보호에 관한 법률」)</p>
      <p>3. 대금 결제 및 재화 등의 공급에 관한 기록: 5년(「전자상거래 등에서의 소비자보호에 관한 법률」)</p>
      <p>4. 소비자의 불만 또는 분쟁 처리에 관한 기록: 3년(「전자상거래 등에서의 소비자보호에 관한 법률」)</p>
      <h2>제3조(개인정보 수집 방법)</h2>
      <p>"회사"는 다음 방법으로 개인정보를 수집합니다.</p>
      <p>1. "앱"·"홈페이지"(회원가입, 본인인증, 기능 설정, 쿠폰 신청, 이벤트 응모), 고객센터 상담</p>
      <p>2. SNS 로그인 제공자 및 제휴사(LG U+, SKT)로부터의 제공</p>
      <p>3. 단말 권한(위치, 알림, 전화, 기기 관리·접근성 또는 스크린 타임) 및 생성정보 수집 툴을 통한 수집</p>
      <h2>제4조(개인정보의 제3자 제공)</h2>
      <p>① "회사"는 "가입자"의 개인정보를 제1조에서 정한 목적 범위 내에서만 처리하며, "가입자"의 사전 동의 없이 본래의 범위를 초과하여 처리하거나 제3자에게 제공하지 않습니다. 다만, 다음 각 호의 경우에는 예외로 합니다.</p>
      <p>1. "가입자"가 사전에 제3자 제공에 동의한 경우</p>
      <p>2. 법령에 특별한 규정이 있거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</p>
      <p>② "가족"(게스트)의 개인정보와 위치정보의 보호자 제공은 제1조 ③에 따릅니다.</p>
      <h2>제5조(개인정보 처리의 위탁)</h2>
      <p>"회사"는 "서비스" 제공을 위한 개인정보 처리업무를 외부에 위탁하지 않습니다. 향후 위탁업무가 발생하는 경우에는 수탁자와 위탁업무 내용을 본 개인정보처리방침을 통하여 지체 없이 공개합니다.</p>
      <h2>제6조(개인정보의 파기)</h2>
      <p>① 개인정보는 해지 등 이용 목적이 달성된 후 제2조의 보존 기간이 경과하면 지체 없이 파기합니다. 단, 가입자 응대 및 수사기관 협조를 위해 해지 후 6개월간 가입자 식별 정보를 보관한 후 삭제합니다.</p>
      <p>② 종이에 출력된 개인정보는 분쇄 또는 소각하고, 전자적 파일은 복원할 수 없는 기술적 방법으로 파기합니다.</p>
      <h2>제7조(개인정보 자동 수집 장치(쿠키)의 설치·운영 및 거부)</h2>
      <p>1. 쿠키의 사용 목적 - 회사는 이용자에게 편리한 서비스를 제공하기 위하여 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트 서버가 이용자의 브라우저에게 전송하는 소량의 정보로서 이용자의 기기에 저장됩니다. 쿠키는 개인을 식별하는 정보를 자동적/능동적으로 수집하지 않으며, 이용자는 언제든지 이러한 쿠키의 저장을 거부하거나 삭제할 수 있습니다.</p>
      <p>2. 쿠키의 설치/운영 및 거부 - 이용자는 웹브라우저 또는 모바일 기기에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. 다만, 쿠키 저장을 거부할 경우 로그인 등 일부 서비스 이용에 어려움이 있을 수 있습니다.</p>
      <p>① Chrome : [설정] &gt; [개인 정보 보호 및 보안] &gt; [서드 파티 쿠키]</p>
      <p>② Microsoft Edge : [설정] &gt; [쿠키 및 사이트 권한] &gt; [쿠키 및 사이트 데이터 관리 및 삭제]</p>
      <p>③ Safari : [설정] &gt; [개인정보 보호] &gt; [모든 쿠키 차단]</p>
      <p>④ 모바일 기기 : 각 운영체제의 설정 메뉴에서 브라우저 쿠키 저장 여부를 설정할 수 있습니다.</p>
      <h2>제8조(미성년자 및 만 14세 미만 아동의 개인정보)</h2>
      <p>① 본 "서비스"는 이동통신사의 월정액 유료부가서비스로, 만 19세 이상의 이동통신 회선 명의자를 기준으로 가입이 이루어지며, 만 19세 미만 미성년자의 가입을 제한합니다.</p>
      <p>② 위 가입 제한 정책에 따라 "회사"는 만 14세 미만 아동을 포함한 미성년자의 개인정보를 수집하지 않으며, 만 14세 미만 아동의 개인정보가 수집된 사실이 확인된 경우 지체 없이 해당 정보를 파기합니다.</p>
      <h2>제9조(이용자의 권리와 그 행사방법)</h2>
      <p>① "가입자"는 「개인정보 보호법」 제35조 등에 따라 아래 담당자에게 개인정보의 열람·정정·처리정지·삭제를 청구할 수 있으며, "회사"는 이를 지체 없이 처리합니다. 비상 연락처와 가족 정보는 "앱"·"홈페이지"에서 직접 수정·삭제할 수 있습니다.</p>
      <p>- 부서: 대표 / 담당자: 박주형 / 전자우편: help@oceanbleu.co.kr / 전화: 1522-7607</p>
      <p>② 제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 전자우편 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.</p>
      <p>③ 이용자가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</p>
      <p>④ 제1항에 따른 권리 행사는 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</p>
      <p>⑤ 이용자는 개인정보보호법 등 관계법령을 위반하여 회사가 처리하고 있는 이용자 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니 됩니다.</p>
      <p>⑥ 동의의 철회 : 이용자는 서비스 가입을 통한 개인정보의 수집·이용·제공에 대하여 동의하신 내용을 언제든지 철회할 수 있습니다. 동의 철회는 서비스 해지 또는 개인정보 보호책임자에게 서면, 전화, 전자우편 등으로 연락하는 방법으로 할 수 있으며, 회사는 즉시 필요한 조치를 취합니다. 동의를 철회하고 개인정보를 파기하는 등의 조치가 있으면 그 사실을 이용자에게 지체 없이 통지합니다.</p>
      <h2>제10조(개인정보의 안전성 확보 조치)</h2>
      <p>회사는 「개인정보 보호법」 제29조 및 같은 법 시행령 제30조에 따라 개인정보의 안전성 확보를 위하여 다음과 같은 조치를 취하고 있습니다.</p>
      <p>① 관리적 조치 : 내부관리계획의 수립·시행, 개인정보 취급 직원의 최소화 및 정기적 교육</p>
      <p>② 접근 통제 : 개인정보처리시스템에 대한 접근 권한의 부여·변경·말소 관리, 침입차단시스템 등을 이용한 외부로부터의 무단 접근 통제</p>
      <p>③ 암호화 : 개인정보의 안전한 저장·전송을 위한 암호화 적용</p>
      <p>④ 접속기록 관리 : 개인정보처리시스템 접속기록의 보관 및 위·변조 방지를 위한 조치</p>
      <p>⑤ 보안프로그램 : 해킹이나 컴퓨터 바이러스 등에 대비한 보안프로그램의 설치 및 주기적 갱신·점검</p>
      <p>⑥ 물리적 조치 : 전산실, 자료보관실 등의 접근 통제</p>
      <h2>제11조(개인정보 보호책임자)</h2>
      <div class="table-wrap"><table>
      <thead>
      <tr>
      <th><strong>구분</strong></th>
      <th><strong>부서</strong></th>
      <th><strong>성명</strong></th>
      <th><strong>전자우편</strong></th>
      <th><strong>전화번호</strong></th>
      </tr>
      </thead>
      <tbody>
      <tr>
      <td>개인정보 보호책임자</td>
      <td>대표</td>
      <td>박주형</td>
      <td>help@oceanbleu.co.kr</td>
      <td>1522-7607</td>
      </tr>
      </tbody>
      </table></div>
      <h2>제12조(권익침해 구제방법)</h2>
      <p>이용자는 다음 기관에 개인정보 침해에 대한 피해구제, 상담 등을 문의할 수 있습니다.</p>
      <p>- 개인정보 침해신고센터(한국인터넷진흥원): privacy.kisa.or.kr / 국번없이 118</p>
      <p>- 개인정보 분쟁조정위원회: www.kopico.go.kr / 국번없이 1833-6972</p>
      <p>- 대검찰청: www.spo.go.kr / 국번없이 1301</p>
      <p>- 경찰청: ecrm.police.go.kr / 국번없이 182</p>
      <h2>[부칙]</h2>
      <p>① 본 개인정보처리방침은 2026년 10월 29일부터 시행합니다.</p>
      <p>② "회사"는 개인정보처리방침을 변경하는 경우 변경 사항을 시행 7일 전부터 "서비스" 내 공지사항을 통하여 고지합니다. 다만, "가입자"의 권리에 중대한 변경이 발생하는 경우에는 최소 30일 전에 고지합니다.</p>
    </div>
    <template #footer>
      <div class="btn-group">
        <button class="btn btn-md btn-close" @click="handleClose">
          <span class="sr-only">닫기</span>
          <i class="ico ico-close-black-xl"></i>
        </button>
      </div>
    </template>
  </ModalPopup>
</template>
<script setup>
// Props 정의
const props = defineProps({
  isVisible: {
    type: Boolean,
    default: false,
  },
});

// Emits 정의
const emit = defineEmits(["close", "confirm"]);

// Methods
const handleConfirm = () => {
  emit("confirm");
};

const handleClose = () => {
  emit("close");
};
</script>
<style scoped>
body {
  font-family: "Malgun Gothic", "맑은 고딕", sans-serif;
  line-height: 1.7;
  color: #222;
  max-width: 860px;
  margin: 40px auto;
  padding: 0 24px;
}
h1 {
  font-size: 22px;
  border-bottom: 2px solid #333;
  padding-bottom: 12px;
  margin-bottom: 8px;
}
h2 {
  font-size: 17px;
  margin-top: 40px;
  margin-bottom: 12px;
  color: #1a1a1a;
  border-left: 4px solid #2b4a7e;
  padding-left: 10px;
}
p {
  margin: 10px 0;
}
.table-wrap {
  overflow-x: auto;
}
table {
  border-collapse: collapse;
  width: 100%;
  margin: 14px 0 20px 0;
  font-size: 14px;
}
th,
td {
  border: 1px solid #ccc;
  padding: 8px 10px;
  text-align: left;
  vertical-align: top;
}
th {
  background-color: #f2f4f7;
  font-weight: bold;
}
.meta {
  color: #666;
  font-size: 13px;
  margin-bottom: 24px;
}
hr {
  margin: 40px 0 20px 0;
  border: none;
  border-top: 1px solid #ddd;
}
.note {
  background: #fff8e6;
  border: 1px solid #f0d98c;
  padding: 10px 14px;
  border-radius: 4px;
  font-size: 13px;
  margin: 10px 0;
}
ol {
  margin: 8px 0;
  padding-left: 22px;
}
</style>
